import React, { useContext } from 'react';
import { AppContext } from '../../state';
import { IUserPreferences } from '__core/models';
import { StandardForm, IFormData, SubHeader, WrappedSwitch } from 'components/forms';
import { IApiWriteRouteResponse } from '__core/api';


export const UserPreferences = () => {

    const { state: { customer, userAccount, api }, dispatch } = useContext(AppContext);
    if (!userAccount || !customer) return null;

    const formData: IFormData<IUserPreferences> = ({
        data: {
            darkMode = false,
            rbi_getServerStatus = false,
            rbi_getSubscriptionStatus = false,
            getServerDown = false,
        },
        update,
    }) =>
        <>
            {/*
            <SubHeader label='Display' help={[]}>
                <WrappedSwitch
                    label="Dark Mode"
                    help={[]}
                    value={darkMode}
                    onChange={darkMode => update({ darkMode })}
                />
            </SubHeader>
            */}

            <SubHeader label='Notifications' help={[]}>
                <WrappedSwitch
                    label="Server Connection Down"
                    help={[]}
                    value={getServerDown}
                    onChange={getServerDown => update({ getServerDown })}
                />
            </SubHeader>
            {userAccount._is_rbi &&
                <SubHeader label='RBI Notifications' help={[]}>
                    <WrappedSwitch
                        label="Server Status (daily)"
                        help={[]}
                        value={rbi_getServerStatus}
                        onChange={rbi_getServerStatus => update({ rbi_getServerStatus })}
                    />
                    <WrappedSwitch
                        label="Subscription Status (monthly)"
                        help={[]}
                        value={rbi_getSubscriptionStatus}
                        onChange={rbi_getSubscriptionStatus => update({ rbi_getSubscriptionStatus })}
                    />
                </SubHeader>
            }
        </>

    const onSave = async (preferences: IUserPreferences): Promise<IApiWriteRouteResponse> => {
        const res = await api.write.userAccount.updatePreferences({ customer_id: customer.id, user_account_id: userAccount.id, preferences });
        if (res.success) dispatch({ type: 'update-user-preferences', preferences });
        return res;
    };

    return <StandardForm
        title="Preferences"
        loadItemPermission={async () => true}
        onLoad={async () => userAccount!.preferences}
        getNew={() => ({})}
        onUpdate={onSave}
        onInsert={onSave}
        formData={formData} />
}